import { type FC, useEffect } from "react";
import { type DialogProps, MctDialog } from "./MctDialog";

export const MandatoryDialog: FC<Omit<DialogProps, "backdropClickExits">> = ({
  children,
  ...otherProps
}) => {
  useEffect(() => {
    const handleEscapeButton = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleEscapeButton, { capture: true });
    return () => document.removeEventListener("keydown", handleEscapeButton);
  }, []);

  return (
    <MctDialog backdropClickExits={false} {...otherProps}>
      {children}
    </MctDialog>
  );
};
